import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-option-label',
  standalone: true,
  imports: [],
  templateUrl: './option-label.component.html',
  styleUrl: './option-label.component.css',
})
export class OptionLabelComponent {
@Input({ required: true }) label!: string;
  @Input() isExclusive: boolean = false;
}